import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getConfigFailed,
  getConfigSuccess,
  GET_CONFIG_START,
  GET_CONFIG_START_ACTION
} from '../actions/config/getConfigAction';
import * as configService from '../../services/config/configService';

import { sortBy } from '../actions/assets/assetsActions';
import get from 'lodash/get';
import { Config } from '../../types/logic';

function* getConfig(action: GET_CONFIG_START_ACTION): any {
  try {
    const config: Config = yield call(configService.getConfig);

    const sortByDefaultValue = get(config, ['webapp', 'sortBy', 0])
      ? {
          label: config.webapp.sortBy[0].label,
          value: config.webapp.sortBy[0].label
        }
      : null;

    yield put(getConfigSuccess(config));
    if (sortByDefaultValue) {
      yield put(sortBy(sortByDefaultValue));
    }
  } catch (e: unknown) {
    yield put(getConfigFailed((e as { message: string })?.message));
  }
}

export default function* facetSaga() {
  yield takeLatest(GET_CONFIG_START, getConfig);
}
